import type {SocialAccount} from '@Components/social-media/account.vo';

export const TIKTOK_VIDEO_ACTION_ICON_PATHS: string[] = [
  'socialmedia/heart-icon-tiktok.svg',
  'socialmedia/message-icon-tiktok.svg',
  'socialmedia/bookmark-icon-tiktok.svg',
  'socialmedia/share-external-icon-tiktok.svg',
];
export const TIKTOK_VIDEO_FOLLOW_ICON_PATH = 'socialmedia/follow-icon-tiktok.svg';

export interface TiktokOverlayProps {
  account: SocialAccount;
  caption: string;
}
